import React from 'react';
import { X, Copy } from 'lucide-react';

// mandatory=true esconde o X e trava o fechamento por clique fora até o slug estar salvo
// (usado no onboarding, Layout.jsx). Na tela de Agenda (mandatory=false) fecha a qualquer momento.
export default function BookingLinkModal({
  open, mandatory, link, slug, slugInput, setSlugInput, savingSlug, onSave, onCopy, onClose,
}) {
  if (!open) return null;
  const canClose = !mandatory || !!slug;

  return (
    <div
      className="fixed inset-0 z-50 bg-black/80 flex items-center justify-center p-4"
      onClick={() => canClose && onClose()}
    >
      <div className="bg-zinc-900 border border-zinc-800 rounded-2xl w-full max-w-md" onClick={e => e.stopPropagation()}>
        <div className="flex items-center justify-between p-5 border-b border-zinc-800">
          <h2 className="font-heading font-semibold text-white">Link de agendamento</h2>
          {canClose && (
            <button onClick={onClose} className="text-zinc-500 hover:text-white"><X size={20} /></button>
          )}
        </div>
        <div className="p-5 space-y-3">
          {mandatory && !slug && (
            <div className="bg-orange-500/10 border border-orange-500/30 rounded-xl p-3 text-xs text-orange-400">
              Antes de continuar, defina o endereço personalizado do seu link de agendamento abaixo. Sem isso, o link enviado aos clientes vem com um código difícil de lembrar.
            </div>
          )}
          <p className="text-xs text-zinc-500">
            Cole esse link na resposta automática do seu WhatsApp Business (ou envie manualmente). É o mesmo link pra todos os clientes — quem abrir informa o WhatsApp e agenda direto.
          </p>
          <div className="flex items-center gap-2">
            <input readOnly className="field-input flex-1 text-xs" value={link} />
            <button onClick={onCopy} className="p-2.5 bg-orange-500 hover:bg-orange-400 text-white rounded-xl transition-colors">
              <Copy size={15} />
            </button>
          </div>
          <div className="pt-2 border-t border-zinc-800 space-y-2">
            <label className="text-xs text-zinc-500">
              Personalize o endereço do link (ex.: stopcar) em vez do código aleatório
            </label>
            <div className="flex items-center gap-2">
              <span className="text-xs text-zinc-500 whitespace-nowrap">agendar.orcfacil.com/</span>
              <input
                className="field-input flex-1 text-xs"
                placeholder="nome-da-empresa"
                value={slugInput}
                onChange={e => setSlugInput(e.target.value.toLowerCase().replace(/[^a-z0-9-]/g, ''))}
              />
              <button
                onClick={onSave}
                disabled={savingSlug || !slugInput || slugInput === slug}
                className="px-3 py-2.5 bg-zinc-800 hover:bg-zinc-700 disabled:opacity-50 text-white text-xs font-medium rounded-xl transition-colors whitespace-nowrap">
                {savingSlug ? 'Salvando...' : 'Salvar'}
              </button>
            </div>
          </div>
          {mandatory && slug && (
            <button
              onClick={onClose}
              className="w-full bg-orange-500 hover:bg-orange-400 text-white font-semibold px-5 py-2.5 rounded-xl transition-colors text-sm">
              Fechar
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
